/*
  Namea-udgave af Dawns media-gallery.
  Billederne ligger fast: et variantskift flytter ikke længere billedet forrest i rækken,
  det viser bare det rigtige billede. Miniaturerne er et almindeligt gitter (namea-thumbs),
  ikke en slider.
*/
if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((item) => {
          const button = item.querySelector('button');
          if (button) button.addEventListener('click', this.setActiveMedia.bind(this, item.dataset.target, false));
        });
        if ((this.dataset.desktopLayout || '').includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        this.setupTabs();
      }

      // Mobil: faner over miniaturerne ("Inspiration", "1 · Fløjlsrygsæk", …), så man kan se,
      // hvilken taske billederne hører til. Rækken viser kun den valgte fanes billeder.
      setupTabs() {
        const thumbs = this.elements.thumbnails;
        const groups = Array.from(thumbs.querySelectorAll('.namea-thumbs__group')).filter(
          (group) => group.querySelector('.namea-thumbs__label') && group.querySelector('[data-target]')
        );
        if (groups.length < 2) return;
        this.thumbGroups = groups;

        const bar = document.createElement('div');
        bar.className = 'namea-tabs';
        bar.setAttribute('role', 'tablist');
        bar.setAttribute('aria-label', 'Billedgrupper');
        groups.forEach((group) => {
          const label = group.querySelector('.namea-thumbs__label').textContent.replace(/\s+/g, ' ').trim();
          const tab = document.createElement('button');
          tab.type = 'button';
          tab.className = 'namea-tabs__tab';
          tab.setAttribute('role', 'tab');
          tab.textContent = /^inspiration/i.test(label) ? 'Inspiration' : label;
          tab.addEventListener('click', () => {
            const first = group.querySelector('[data-target]');
            if (first) this.setActiveMedia(first.dataset.target, false);
          });
          bar.appendChild(tab);
        });
        thumbs.parentNode.insertBefore(bar, thumbs);
        thumbs.classList.add('namea-thumbs--tabbed');
        this.tabBar = bar;

        const current = thumbs.querySelector('button[aria-current="true"]');
        this.setCurrentGroup(current ? current.closest('.namea-thumbs__group') : groups[0]);
      }

      setCurrentGroup(group) {
        if (!this.thumbGroups || !group) return;
        this.thumbGroups.forEach((item, index) => {
          const isCurrent = item === group;
          item.classList.toggle('is-current', isCurrent);
          const tab = this.tabBar.children[index];
          if (!tab) return;
          tab.classList.toggle('is-active', isCurrent);
          tab.setAttribute('aria-selected', String(isCurrent));
          if (isCurrent && this.tabBar.scrollWidth > this.tabBar.clientWidth + 1) {
            const left = tab.offsetLeft - (this.tabBar.clientWidth - tab.offsetWidth) / 2;
            this.tabBar.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
          }
        });
      }

      onSlideChanged(event) {
        const current = event.detail && event.detail.currentElement;
        if (!current || !this.elements.thumbnails) return;
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${current.dataset.mediaId}"]`);
        this.setActiveThumbnail(thumbnail);
      }

      // prepend ignoreres med vilje: billederne skal blive, hvor de er.
      setActiveMedia(mediaId, prepend) {
        const viewer = this.elements.viewer;
        if (!viewer) return;
        const activeMedia =
          viewer.querySelector(`[data-media-id="${mediaId}"]`) || viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${activeMedia.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        const button = thumbnail.querySelector('button');
        if (button) button.setAttribute('aria-current', 'true');
        this.setCurrentGroup(thumbnail.closest('.namea-thumbs__group'));

        const thumbs = this.elements.thumbnails;
        if (thumbs.slider && typeof thumbs.isSlideVisible === 'function') {
          if (thumbs.isSlideVisible(thumbnail, 10)) return;
          thumbs.slider.scrollTo({ left: thumbnail.offsetLeft });
          return;
        }
        // Mobil: miniaturerne er én vandret række – rul den valgte ind i midten.
        if (thumbs.scrollWidth > thumbs.clientWidth + 1) {
          const left = thumbnail.offsetLeft - (thumbs.clientWidth - thumbnail.offsetWidth) / 2;
          thumbs.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image || !this.elements.liveRegion) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
